import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApplicationCard from "../../components/parent/ApplicationCard";
import Header from "../../components/parent/Header";
import API_ENDPOINTS from "../../utils/apiEndpoints";

function Dashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("");
  const [tabs, setTabs] = useState([]);
  const [tabData, setTabData] = useState({});
  const [showPrerequisitesModal, setShowPrerequisitesModal] = useState(false);

  // console.log(tabData,"AATTTTT");


  const handleLogout = async () => {
    const token = localStorage.getItem("parentToken");

    try {
      const res = await fetch(API_ENDPOINTS.PARENT_LOGOUT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token} `,
        },
      });

      const data = await res.json();
      // console.log(data, "logout response");

      if (res.ok && data.message === "Logged out") {
        localStorage.removeItem("parentToken");
        alert("Logged out successfully");
        navigate("/");
      } else {
        alert("Logout failed. Please try again.");
      }
    } catch (error) {
      console.error("Logout error:", error);
      alert("An error occurred during logout.");
    }
  };

  const buttons = [
    {
      text: "Home",
      onClick: () => (window.location.href = "https://www.ssvkchokkady.org/"),
      color: "bg-blue-500 text-white"
    },
    {
      text: `${Array.isArray(tabData?.approved_applications) && tabData.approved_applications.length > 0
        ? "Apply for another Child"
        : "Apply"
        } `,
      onClick: () => setShowPrerequisitesModal(true),
      color: "bg-blue-500 text-white"
    },
    { text: "Logout", onClick: handleLogout, color: "bg-red-500 text-white" },
  ];



  useEffect(() => {
    const fetchDashboardData = async () => {
      // const token = "31|MYvoW80VHGZCLldkaTbMUda4pozfF6CFGt99Lprp68afdcbe";
      const token = localStorage.getItem("parentToken");
      // console.log(token, "tokennnn");

      if (!token) {
        console.error("No token found in localStorage");
        return;
      }

      try {
        const response = await fetch(API_ENDPOINTS.PARENT_DASHBOARD, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token} `,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText} `);
        }

        const data = await response.json();
        const tabNames = Object.keys(data.data);

        setTabs(tabNames);
        setTabData(data.data);
        if (tabNames.length > 0) {
          // setActiveTab(tabNames[0]);
          setActiveTab(tabNames[1]);
        }
      } catch (error) {
        console.error("Failed to fetch dashboard data:", error.message);
      }
    };

    fetchDashboardData();
  }, []);

  const handlePayNow = async (id, isPending = false) => {
    // console.log("Payment initiated for student_id:", id);
    const token = localStorage.getItem("parentToken");

    try {
      const endpoint = API_ENDPOINTS.INITIATE_PENDING_PAYMENT || 'http://127.0.0.1:8000/api/admission/initiatePendingPayment';

      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ student_id: id })
      });

      const data = await res.json();

      if (res.ok) {
        // Assuming the API returns payment payload, we should now navigate to payment page with that payload
        // console.log("Payment payload received:", data);
        navigate(`/payment/${id}`, { state: { isPending, paymentData: data } });
      } else {
        alert(data.message || "Failed to initiate payment");
      }
    } catch (error) {
      console.error("Payment Error:", error);
      alert("An error occurred while initiating payment.");
    }
  };

  const handleContinueApplication = async (detailsUrl, appId) => {
    const token = localStorage.getItem("parentToken");
    try {
      const res = await fetch(detailsUrl, {
        headers: { Authorization: `Bearer ${token} ` }
      });
      const data = await res.json();
      if (data.success) {
        const student = data.data;
        if (!student.address1) return navigate(`/address-info/${appId}`);
        if (!student.father_name) return navigate(`/parent-info/${appId}`);
        if (!student.medium) return navigate(`/academic-info/${appId}`);
        if (!student.student_photo) return navigate(`/file-uploads/${appId}`);
        return navigate(`/admission-rules/${appId}`);
      }
    } catch (e) {
      console.error("Failed to continue application:", e);
    }
  };

  return (
    <>
      <Header logo="ssvk-logo.png" buttons={buttons} />

      <div className="w-full max-w-full sm:px-20 mx-auto p-6">
        {/* Tab Buttons */}
        <div className="flex flex-wrap border-b border-blue-300">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={`flex-1 py-3 text-center font-medium text-blue-700 p-3 focus:outline-none ${activeTab === tab ? "bg-blue-200 font-bold" : ""
                }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab
                .toLowerCase() // Convert to lowercase
                .replace(/_/g, " ") // Replace underscores with spaces
                .replace(/\b\w/g, (char) => char.toUpperCase())} {/* Capitalize each word */}
            </button>
          ))}
        </div>


        {/* Cards Display */}
        <div className="mt-4 space-y-4 max-h-[500px] overflow-y-auto">
          {tabData[activeTab] && tabData[activeTab].length > 0 ? (
            tabData[activeTab].map((item, index) => (
              <ApplicationCard
                key={index}
                item={item}
                isPendingPayment={activeTab === "pending_payments"}
                onPayNow={handlePayNow}
                onContinue={handleContinueApplication}
              />
            ))
          ) : (
            <p className="text-center text-gray-500">
              No data available for this tab. Please apply to see your details here.
            </p>
          )}
        </div>
      </div>

      {/* Prerequisites Modal */}
      {showPrerequisitesModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto transform transition-all">
            <div className="p-6 border-b border-gray-200">
              <h3 className="text-xl font-bold text-gray-900">Important Prerequisites</h3>
              <p className="text-gray-600 text-sm mt-1">Please ensure you have all the following details and documents ready before starting the application.</p>
            </div>

            <div className="p-6 space-y-6">
              {/* Data Requirements */}
              <div>
                <h4 className="text-lg font-semibold text-blue-700 mb-3 border-b pb-1">Required Information</h4>
                <ul className="list-disc pl-5 text-gray-700 space-y-2">
                  <li>Student's SATS Number</li>
                  <li>Student's PEN Number</li>
                  <li>Marks of the latest annual exam</li>
                  <li>Student's Blood Group</li>
                  <li>Previous School Details (Name & Address)</li>
                </ul>
              </div>

              {/* Document Requirements */}
              <div>
                <h4 className="text-lg font-semibold text-blue-700 mb-3 border-b pb-1">Required Documents <span className="text-sm font-normal text-gray-500">(Max 2MB per file)</span></h4>
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 mb-4 rounded-r-lg">
                  <p className="text-sm text-yellow-700">
                    <span className="font-bold">Important:</span> Please ensure your uploaded file names <strong>do not contain any spaces</strong> (e.g., use <code className="bg-yellow-100 px-1 rounded">my_photo.jpg</code> instead of <code className="bg-yellow-100 px-1 rounded">my photo.jpg</code>).
                  </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-700">
                  <div className="bg-blue-50 p-3 rounded-lg border border-blue-100">
                    <span className="font-semibold block mb-1">Student Photo</span>
                    <span className="text-xs text-gray-500">Format: JPG, PNG, JPEG</span>
                  </div>
                  <div className="bg-blue-50 p-3 rounded-lg border border-blue-100">
                    <span className="font-semibold block mb-1">Aadhaar Cards</span>
                    <span className="text-xs text-gray-500">Format: PDF Only<br />(Student, Father, Mother)</span>
                  </div>
                  <div className="bg-blue-50 p-3 rounded-lg border border-blue-100">
                    <span className="font-semibold block mb-1">Signatures</span>
                    <span className="text-xs text-gray-500">Format: PDF Only<br />(Student, Father, Mother)</span>
                  </div>
                  <div className="bg-blue-50 p-3 rounded-lg border border-blue-100">
                    <span className="font-semibold block mb-1">Health Certificate (Optional)</span>
                    <span className="text-xs text-gray-500">Format: PDF Only<br />(Only if applicable)</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end space-x-3 rounded-b-lg">
              <button
                type="button"
                onClick={() => setShowPrerequisitesModal(false)}
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 font-medium transition"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={() => {
                  setShowPrerequisitesModal(false);
                  navigate("/basic-info");
                }}
                className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium shadow-sm transition"
              >
                Proceed to Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Dashboard;
